export default __webpack_public_path__ + "static/media/hvar_island_yachting.0ae26d66.webp";